var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 -2 24 24",
    id: "meteor-icon-kit__regular-twitter",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54752 20C16.6042 20 21.5578 12.3048 21.5578 5.63156C21.5578 5.41299 21.5578 5.19541 21.5434 4.97881C22.507 4.26394 23.3389 3.37881 24 2.36484C23.1013 2.77324 22.148 3.04106 21.1718 3.15937C22.1998 2.52826 22.9691 1.53563 23.3366 0.36622C22.3701 0.95444 21.3126 1.36899 20.2099 1.59198C18.6836 -0.0725 16.2583 -0.47988 14.294 0.59826C12.3296 1.6764 11.3148 3.97194 11.8186 6.19768C7.85942 5.99412 4.1707 4.0763 1.6704 0.9215C0.363478 3.22892 1.03103 6.1808 3.19488 7.66268C2.41127 7.63886 1.64475 7.42207 0.96 7.0306C0.96 7.05128 0.96 7.07294 0.96 7.09459C0.960641 9.4985 2.61288 11.5689 4.9104 12.0449C4.18547 12.2476 3.42488 12.2773 2.68704 12.1315C3.33211 14.1887 5.18071 15.5979 7.28736 15.6385C5.54375 17.0438 3.38982 17.8068 1.17216 17.8045C0.780387 17.8037 0.388996 17.7794 0 17.7316C2.25181 19.2136 4.87192 19.9997 7.54752 19.9961",
    fill: "#4a4a4a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f03a4980597f3f70061d542219a8c117.svg";
export { ForwardRef as ReactComponent };